import { Stack, Text } from "@mantine/core";

import { SeoOpeningTagline } from "./SeoCommon";
import { SeoFooter } from "./SeoFooter";
import { SeoSection } from "./SeoSection";

export const Pmdg777MarketingSeo = (): JSX.Element => {
  return (
    <Stack>
      <SeoSection title="High-fidelity long-haul">
        <Text fz="medium">
          The PMDG 777 is a faithfully detailed simulation of the world's largest twin-jet
          commercial airliner. The triple seven is brimming with advanced automation and complex
          systems that enable the massive airliner to cover truly impressive distances. Learning
          these systems can be daunting at first. Fortunately, <SeoOpeningTagline />
        </Text>
      </SeoSection>
      <SeoSection title="">
        <Text fz="medium">
          Our 777 checklist template makes it easy to get started building your very own checklist.
          Use our web-based editor to add or remove checklist items or flows as you see fit. You can
          even add checklists to help you remember to configure your favorite addon software, or
          write down memory items while you learn the aircraft. Checklists are saved in your
          browser, so you can come back and update them as your operations with the 777 evolve over
          time.
        </Text>
        <SeoFooter />
      </SeoSection>
    </Stack>
  );
};
